<div class="main-div">
  <lib-language-header></lib-language-header>
  <lib-header [headerText]="header">
    <div class="container">
      <p class="text" i18n>Our project partners</p>
      <div class="logos">
        <div style="height: 3rem; margin-right: 1rem"><img alt="bet" src="assets/BET_Logo.svg"/></div>
        <div style="height:2.5rem"><img alt="exceeding" src="assets/es_logo.png"/></div>
      </div>
    </div>
  </lib-header>
  <div class="router-outlet-container">
    <app-horizontal-menu [headers]="headers" alignment="center" menuHeight="4rem"></app-horizontal-menu>
    <router-outlet></router-outlet>
  </div>
</div>
